import { ItemAggregateTab, type ItemAggregateConfig } from '@/components/ItemAggregateTab'

const CONFIG: ItemAggregateConfig = {
  entityShort: '입고',
  entityDate: '입고일자',
  entityNo: '입고번호',
  partnerLabel: '매입처',
  partnerFilterPlaceholder: '전체 매입처',
  emptyDetailText: '이 품목의 입고 내역이 없습니다.',

  summaryApi: '/api/receiving/item-summary',
  summaryExportApi: '/api/receiving/item-summary/export',
  detailApi: '/api/receiving/lines',
  queryKeyPrefix: 'rcv-item-summary',
  excelFilePrefix: '입고현황_품목별',

  linkPath: '/main/receiving',
  partnerBizClass: 'vendor',
}

export function ReceivingByItemTab() {
  return <ItemAggregateTab config={CONFIG} />
}
